// frontend/src/pages/public/IntakeProcess/IntakeProcessPage.tsx
import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../../components/SEO/SEO";
import PublicHeader from "../../../components/PublicHeader/PublicHeader";
import PublicFooter from "../../../components/PublicFooter/PublicFooter";

import AnimatedStepFlow from "../../../components/public-info/sections/AnimatedStepFlow";
import FAQSection from "../../../components/public-info/sections/FAQSection";

import {
  intakeProcessHero,
  intakeProcessSteps,
  intakeProcessRules,
  intakeProcessFAQ,
  intakeProcessCtas,
} from "./IntakeProcessContent";

import "./IntakeProcessPage.css";

function iconNode(src: string, alt = ""): React.ReactNode {
  return (
    <img
      src={src}
      alt={alt}
      style={{ width: 22, height: 22, display: "block" }}
    />
  );
}

export default function IntakeProcessPage() {
  return (
    <div className="ocf-intake">
      <SEO
        title="Intake Process"
        description="Understand the patient intake process on AcceptingMD. Learn what information you'll need and how clinics review your request."
      />
      <PublicHeader variant="solid" />

      {/* Hero - matches How It Works style */}
      <header className="ocf-intake-hero">
        <div className="ocf-intake-hero-inner">
          <div className="ocf-intake-hero-badge">{intakeProcessHero.eyebrow}</div>
          <h1>{intakeProcessHero.title}</h1>
          <p className="ocf-intake-hero-text">{intakeProcessHero.subtitle}</p>
        </div>
      </header>

      <main className="ocf-intake-main">
        <div className="ocf-intake-sections">
          {/* Steps */}
          <AnimatedStepFlow
            id={intakeProcessSteps.id}
            title={intakeProcessSteps.title}
            subtitle={intakeProcessSteps.subtitle}
            compact
            steps={intakeProcessSteps.steps.map((s) => ({
              title: s.title,
              description: s.description,
              icon: iconNode(s.iconSrc),
            }))}
          />

          {/* Rules */}
          <section className="ocf-intake-rules">
            <h2 className="ocf-intake-rules-title">{intakeProcessRules.title}</h2>
            <div className="ocf-intake-rules-grid">
              {intakeProcessRules.rules.map((rule, idx) => (
                <div key={idx} className="ocf-intake-rule-card">
                  <div className="ocf-intake-rule-icon">
                    {iconNode(rule.iconSrc)}
                  </div>
                  <div className="ocf-intake-rule-content">
                    <h3>{rule.title}</h3>
                    <p>{rule.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* FAQ */}
          <FAQSection
            id={intakeProcessFAQ.id}
            title={intakeProcessFAQ.title}
            items={intakeProcessFAQ.items}
          />
        </div>
      </main>

      {/* CTA - full width blue gradient */}
      <section className="ocf-intake-cta">
        <div className="ocf-intake-cta-inner">
          <h2>{intakeProcessCtas.title}</h2>
          <p>{intakeProcessCtas.subtitle}</p>
          <div className="ocf-intake-cta-buttons">
            <Link
              to={intakeProcessCtas.primaryCta.to}
              className="ocf-intake-cta-btn ocf-intake-cta-btn--primary"
            >
              {intakeProcessCtas.primaryCta.label}
            </Link>
            <Link
              to={intakeProcessCtas.secondaryCta.to}
              className="ocf-intake-cta-btn ocf-intake-cta-btn--ghost"
            >
              {intakeProcessCtas.secondaryCta.label}
            </Link>
          </div>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
}
